
















































































































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Inject } from 'inversify-props'
import type { EstacaoDeImpressaoServiceAdapter } from '@/usecases'
import {
	dpisDeImpressoraTermica,
	EstacaoDeImpressao,
	linguagensDeImpressora,
	TAMANHO_MAXIMO_DO_IDENTIFICADOR,
	TAMANHO_MAXIMO_DO_NOME,
} from '@/models/EstacaoDeImpressao'

const ENDERECO_DE_REDE = /^[A-Za-z0-9.\-_]+:\d{1,5}$/
const PORTA_MAXIMA = 65535

@Component
export default class DialogoDeEdicaoDeEstacaoDeImpressao extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeNome!: HTMLInputElement

	@Inject('EstacaoDeImpressaoServiceAdapter')
	private estacaoDeImpressaoService!: EstacaoDeImpressaoServiceAdapter

	estacao: EstacaoDeImpressao | null = null
	mostra = false
	salvando = false
	obrigatorio = obrigatorio

	opcoesDeDpi = dpisDeImpressoraTermica.map(valor => ({
		valor,
		rotulo: `${valor} dpi`,
	}))

	linguagens = linguagensDeImpressora
	TAMANHO_MAXIMO_DO_NOME = TAMANHO_MAXIMO_DO_NOME
	TAMANHO_MAXIMO_DO_IDENTIFICADOR = TAMANHO_MAXIMO_DO_IDENTIFICADOR

	precisaDeTooltip(valor: string | null) {
		return (valor?.length ?? 0) > 40
	}

	get linguagemAindaNaoImprime() {
		const linguagem = linguagensDeImpressora.find(item => item.valor === this.estacao?.linguagem)
		return !!linguagem && !linguagem.imprime
	}

	mostrar(estacao: EstacaoDeImpressao) {
		this.estacao = JSON.parse(JSON.stringify(estacao))
		this.mostra = true

		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeNome.focus()
		})
	}

	esconder() {
		this.estacao = null
		this.mostra = false
	}

	get criandoNova() {
		return !this.estacao?.id
	}

	get ehRede() {
		return this.estacao?.tipoDeConexao === 'REDE'
	}

	get rotuloDoIdentificador() {
		return this.ehRede ? 'Endereço da impressora na rede' : 'Nome da impressora no Windows'
	}

	get placeholderDoIdentificador() {
		return this.ehRede ? '192.168.0.50:9100' : 'Ex.: ZDesigner GK420t'
	}

	get dicaDoIdentificador() {
		return this.ehRede
			? 'No formato ip:porta'
			: 'Como aparece em Dispositivos e Impressoras, no computador da loja'
	}

	get regrasDoIdentificador() {
		return [
			() => obrigatorio(this.estacao?.identificadorDaImpressora?.trim()),
			() => this.enderecoDeRedeValido(),
		]
	}

	enderecoDeRedeValido(): true | string {
		if (!this.ehRede) return true
		const endereco = this.estacao?.identificadorDaImpressora?.trim() || ''
		if (!endereco) return true
		if (!ENDERECO_DE_REDE.test(endereco)) {
			return 'Informe no formato ip:porta, como 192.168.0.50:9100'
		}
		const porta = Number(endereco.substring(endereco.lastIndexOf(':') + 1))
		if (porta <= 0 || porta > PORTA_MAXIMA) return 'Porta inválida'
		return true
	}

	aoTrocarTipoDeConexao() {
		if (!this.estacao) return
		this.estacao.identificadorDaImpressora = ''
		setTimeout(() => this.form.resetValidation())
	}

	async salvar() {
		if (!this.estacao) return
		if (!this.form.validate()) return

		try {
			this.salvando = true
			const estacaoSalva = this.criandoNova
				? await this.estacaoDeImpressaoService.createEstacaoDeImpressao(this.estacao)
				: await this.estacaoDeImpressaoService.updateEstacaoDeImpressao(this.estacao.id, this.estacao)

			AlertModule.setSuccess(
				this.criandoNova ? 'Estação de impressão criada' : 'Estação de impressão atualizada',
			)
			this.$emit('salvou', estacaoSalva)
			this.esconder()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}
}
